import React, { useState } from 'react'
import { Tooltip, Button } from 'antd'
import { CopyOutlined } from '@ant-design/icons'

interface CopyButtonProps {
  value: string
  size?: 'small' | 'middle' | 'large'
  style?: React.CSSProperties
  className?: string
}

export const CopyButton: React.FC<CopyButtonProps> = ({
  value,
  size = 'small',
  style,
  className,
}) => {
  const [copied, setCopied] = useState(false)

  const handleCopy = async () => {
    try {
      // Remove any formatting from CPF (dots and hyphens)
      const cleanValue = value || ''

      if (navigator.clipboard) {
        await navigator.clipboard.writeText(cleanValue)
      } else {
        // Fallback for older browsers
        const textArea = document.createElement('textarea')
        textArea.value = cleanValue
        document.body.appendChild(textArea)
        textArea.select()
        document.execCommand('copy')
        document.body.removeChild(textArea)
      }

      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch (err) {
      console.error('Failed to copy CPF:', err)
    }
  }

  return (
    <Tooltip title={copied ? 'Copiado!' : 'Copiar CPF'}>
      <Button
        icon={<CopyOutlined />}
        size={size}
        type="text"
        onClick={handleCopy}
        style={{
          padding: '4px',
          minWidth: 'auto',
          height: 'auto',
          ...style,
        }}
        className={className}
      />
    </Tooltip>
  )
}
